var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fee"},[_c('v-row',[_c('v-col',[_c('span',{staticClass:"font-weight-medium"},[_vm._v(_vm._s(_vm.$t('Trade id:'))+" ")]),_vm._v(" "+_vm._s(_vm.id)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }